export default __webpack_public_path__ + "static/media/pdf_icon.ce08183f.svg";